import { ComponentIds, ProductUtils, ConnectionUtils } from '@inter-ikea-core/core';
import { PlacementResult } from '@inter-ikea-core/core';
export const autoAdaptChildrenAfterReplace = (newEntity, replaceResult, placementService) => {
    const childrenWithNoFuture = replaceResult.childrenResult
        .filter(c => !c.valid) // Only interested in the failed children
        .map(p => p.placedEntity)
        .filter((p) => !!p) // Only non null elements
        .map(child => {
        return autoAdaptEntityWithChildrenIntoHost(child, newEntity, placementService);
    });
    return childrenWithNoFuture;
};
const autoAdaptEntityWithChildrenIntoHost = (entity, hostEntity, placementService) => {
    // First we check if it is still in the scene. We will only execute this
    // code if the placement was invalid, so we start by removing the entity from
    // the secene (and then snap it back later in this method)
    if (entity.hasComponent(ComponentIds.IN_SCENE_COMPONENT_ID)) {
        // Calling removeEntity will create a remove action that is
        // added to the history stack. Since we started a compound action
        // earlier all actions will be combined into one undo step.
        ConnectionUtils.disconnectAndDisposeEntityAndHierarchy(entity);
    }
    // Keep a list of current children
    const oldChildren = ProductUtils.immediateConnectionRootDescendants(entity);
    // Snap entity to hostEntity with auto adapt
    const entityPosition = entity.getComponent(ComponentIds.WORLD_TRANSFORM_COMPONENT_ID)?.transform.position;
    let autoAdaptResult;
    if (entityPosition) {
        autoAdaptResult = placementService.snapToPosition(entity, entityPosition, false);
    }
    else {
        autoAdaptResult = placementService.snapToTarget(entity, hostEntity);
    }
    if (!autoAdaptResult.valid) {
        // If didn't fit try remove all children and snap again
        ConnectionUtils.disconnectAndDisposeEntitiesAndHierarchies(oldChildren);
        if (entityPosition) {
            autoAdaptResult = placementService.snapToPosition(entity, entityPosition, false);
        }
        else {
            autoAdaptResult = placementService.snapToTarget(entity, hostEntity);
        }
    }
    // If could snap to hostEntity put back the removed children using auto adapt.
    // The grandChild will auto adapt to fit the entity if needed. The entity could
    // it self have auto adapded above, and then all children might need to auto adapt
    // as well.
    if (autoAdaptResult.valid) {
        const newChild = autoAdaptResult.placedEntity;
        // If any child was removed, either because the entity auto adapted
        // and lost its children or we removed the child in the code above, we
        // need to snap it back.
        oldChildren.forEach(grandChild => {
            // We can check if the child needs to be resnapped by check if itax
            // is in the scene (has the InSceneComponent). If not, we add it
            // to our entity with snapToTarget() which will auto adapt the child
            // if needed.
            placementService.snapToTarget(grandChild, newChild);
        });
    }
    // If we got the new entity from the autoAdaptResult, use that, else take the original entity
    const placedEntity = autoAdaptResult.placedEntity ? autoAdaptResult.placedEntity : entity;
    return new PlacementResult(autoAdaptResult.warnings, autoAdaptResult.errors, placedEntity);
};
//# sourceMappingURL=autoAdapt.js.map